import { useTranslation } from 'react-i18next';
import { IconButton } from 'shared/ui/IconButton/IconButton';
import { FilterGroup } from './useFilteredTags';

import './FilterResults.scss';

interface FilterResultProps {
  filters: { [group: string]: string[] };
  onRemove: (group: string, value: string) => void;
  filterGroups?: FilterGroup[];
}

export const FilterResults = ({ filters, onRemove, filterGroups }: FilterResultProps) => {
  const { t } = useTranslation('tag');

  if (!filters || Object.keys(filters).length === 0) return null;

  const filterLabels = [
    { label: 'IFRS-FULL', value: 'ifrsFull' },
    { label: 'ESRS-2025', value: 'esrs2025' },
    { label: t('status.approved'), value: 'approved' },
    { label: t('status.draft'), value: 'draft' },
    { label: t('status.need_attention'), value: 'need_attention' },
    { label: t('status.verified'), value: 'verified' },
    { label: t('status.invalid'), value: 'invalid' },
    { label: t('status.unvalidated'), value: 'unvalidated' },
    { label: t('status.valid'), value: 'valid' },
    { label: t('type.numeric'), value: 'nonFraction' },
    { label: t('type.textBlock'), value: 'nonNumeric' },
    { label: t('type.fraction'), value: 'fraction' },
  ];

  const resolveLabel = (group: string, value: string): string => {
    if (filterGroups) {
      const groupObj = filterGroups.find((g) => g.value === group);
      const option = groupObj?.options.find((opt) => opt.value === value);
      if (option) return option.label;
    }
    const optionObj = filterLabels.find((opt) => opt.value === value);
    return optionObj?.label || value;
  };

  return (
    <div className="filter__selected-filters">
      {Object.entries(filters).map(([group, values]) =>
        values?.map((value) => {
          return (
            <span key={group + value} className="filter__selected--pill">
              {resolveLabel(group, value)}
              <IconButton icon="close" variant="transparent" onClick={() => onRemove(group, value)} />
            </span>
          );
        })
      )}
    </div>
  );
};
